import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class About extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'

    return	<div className="about-section pd-top-80">
              <div className="container">
                <div className="row">
                  <div className="col-lg-5 align-self-center">
                    <div className="section-title mb-lg-0">
                      <h2 className="title">A Traveler's <br /> Home</h2>
                      <p>
                        West African Tours Ltd. is an all-inclusive,
                        full-service Destination Management Company based in
                        The Gambia and serving the West African region. We
                        cater to medium-sized tour operators, international
                        cruise companies, M.I.C.E and special interest
                        groups, and are equally suited to small tour
                        companies with specialized packages. Individual
                        travelers can book directly onto a multi-country
                        scheduled tour, or have a personalized tour created.
                      </p>
                      <p>
                        Our team is made up of over 30 trained
                        field, driving and office-based staff dedicated to
                        the quality of travel management you're looking for.
                        Our field staff are instantly recognizable in their
                        batik outfits, and know the country, its history and
                        culture well enough to add real value to a tour.
                        We're equipped with reliable 4-wheel drive vehicles,
                        trucks, and comfortable air-conditioned coaches and
                        minibuses — and with an established network of
                        agents throughout the region, we can advise,
                        organize and assist you wherever you want to travel
                        in West Africa.
                      </p>
                      <p>
                        West African Tours maintains close links with
                        regional tourist authorities and is a proud member
                        of several major international travel associations.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-5 offset-lg-2">
                    <div className="thumb about-section-right-thumb">
                      {/* <img src={publicUrl+"assets/img/TravelAfrica.PNG"} alt="img" /> */}
                      <img src={publicUrl+"assets/img/cruiseShip.png"} alt="img" />
                      <img className="about-absolute-thumb" src={publicUrl+"assets/img/women.png"} alt="img" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

        }
}

export default About